/**
 * Clients page utility module — extracted in iter170 (component split
 * step #2). The bigger tab/panel extractions are tracked in
 * `/app/memory/CODE_QUALITY_REFACTOR.md`; this file holds the
 * pure constants and formatters so they can be reused by the
 * to-be-extracted `ClientProposalsTab` and `ClientSitesTab` without
 * dragging the entire 4,900-LOC Clients.jsx into their import graph.
 */

export const formatCurrency = (value) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);

export const proposalStatusOptions = [
  { value: "draft", label: "Draft" },
  { value: "bid_submitted", label: "Bid Submitted" },
  { value: "open", label: "Open" },
  { value: "won", label: "Won" },
  { value: "lost", label: "Lost" },
];

// Customer health rating. A=top, D=watch-list. Used in the Customer
// list table chip, the side-panel header, and the future
// `ClientProposalsTab` extraction.
export const ratingOptions = [
  { value: "A", label: "A", color: "bg-green-100 text-green-700 border-green-300" },
  { value: "B", label: "B", color: "bg-blue-100 text-blue-700 border-blue-300" },
  { value: "C", label: "C", color: "bg-yellow-100 text-yellow-700 border-yellow-300" },
  { value: "D", label: "D", color: "bg-red-100 text-red-700 border-red-300" },
];
